import React from "react";
import type { FC } from "react";

import { createDisplayNameForCoreInputTextElement } from "../../utils/getDisplayName";
import { createTestIdForCoreInputTextElement } from "../../utils/getTestId";

import type { InputTextLeftProps } from "../../types";

import classes from "./CoreInputTextLeft.styl";

const INPUT_TEXT_LEFT_TEST_ID = createTestIdForCoreInputTextElement("left");

const CoreInputTextLeft: FC<InputTextLeftProps> = ({ children }) => {
    return children ? (
        <div className={classes["left"]} data-tsid={INPUT_TEXT_LEFT_TEST_ID}>
            {children}
        </div>
    ) : null;
};

CoreInputTextLeft.displayName =
    createDisplayNameForCoreInputTextElement("Left");

export default CoreInputTextLeft;
